import styled from 'styled-components'
import { Tabs, TabPanel, TabList, Tab } from 'react-tabs'
import YouTube from 'react-youtube'

export const MoreSports = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  figure {
    height: 250px;
    min-width: 400px;
    background-color: #161d2f;
    position: relative;
    margin: 10px;
    border-radius: 4px;
    cursor: normal;

    .gatsby-image-outer-wrapper,
    .gatsby-image-wrapper {
      position: static !important;
    }

    .gatsby-image-wrapper,
    img {
      min-height: 100%;
      min-width: 90%;
      height: auto !important;
      width: auto !important;
    }
  }
`

export const SportswearImages = styled.section`
  margin: 20px auto 100px;
  > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    figure {
      position: relative;
      margin-bottom: 40px;
      cursor: normal;

      article {
        display: flex;
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 99;
        background: rgba(237, 237, 237, 0.5);
        justify-content: center;
        align-items: center;
        flex-direction: column;

        h6 {
          font-size: 24px;
        }
      }

      &:hover {
        article {
          opacity: 1;
          transition: opacity 0.3s ease-in-out;
        }
        .gatsby-image-wrapper {
          opacity: 0.5;
          transition: opacity 0.3s ease-in-out;
        }
      }
    }

    .gatsby-image-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;

      > div {
        display: none;
      }
    }

    figure,
    .gatsby-image-outer-wrapper,
    .gatsby-image-wrapper {
      width: 340px;
      height: 340px;
      img {
        max-width: 100%;
        max-height: 100%;
        width: auto !important;
        height: auto !important;
        position: relative !important;
      }
    }

    /* .gatsby-image-outer-wrapper,
    .gatsby-image-wrapper {
      &:hover {
        opacity: 0.5;
        transition: opacity 0.3s ease-in-out;
      }
      img {
        padding: 20px;
      }
      @media (max-width: 600px) {
        width: 360px;
        height: 215px;
      }
    } */
  }

  h2 {
    font-weight: 400;
    text-align: center;
  }
`

export const Video = styled(YouTube)`
  margin-top: 25px;
  width: 90vw;
  height: 50.75vw;
  max-height: 576px;
  max-width: 1024px;
  border-radius: 8px;
  margin: 50px auto;
  display: flex;
  justify-content: center;
`

export const Content = styled.div`
  max-width: 850px;
  width: 90%;
  margin: 50px auto 50px;
  text-align: center;
  h2 {
    color: ${props => props.theme.colors.primary};
    i {
      color: #0c67bd;
      font-style: normal;
    }
  }
  span {
    font-size: 22px;
    line-height: 1.4;
    margin: 1rem 0 2rem;
    display: block;
  }
  h4 {
    font-weight: 400;
    color: ${props => props.theme.colors.primary};
    font-size: 20px;
  }
`

export const StyledTabList = styled(TabList)`
  display: inline-flex;
  list-style: none;
  padding: 0;
  border-radius: 30px;
  margin-bottom: 3rem;
  cursor: pointer;

  @media (max-width: 600px) {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }
`

export const StyledTab = styled(Tab)`
  padding: 0.75rem 1.5rem;
  border: 1px solid ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.primary};
  font-weight: 500;

  @media (max-width: 600px) {
    margin-top: 1rem;
  }

  border-radius: 30px;
  margin: 0 0.2rem;

  &.react-tabs__tab--selected {
    color: #fff;
    background-color: ${props => props.theme.colors.primary};
  }

  /* &:last-child {
    border-right: none;
  } */
`

export const StyledTabs = styled(Tabs)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 850px;
  margin: 0 auto 60px;
  width: 90%;

  div {
    h4 {
      font-weight: 400;
      font-size: 20px;
      color: ${props => props.theme.colors.primary};
    }
  }
  h2 {
    font-weight: 400;
    text-align: center;
    margin-bottom: 1em;
  }
`
